import script from "./HlhtAuths.vue?vue&type=script&lang=ts&setup=true"
export * from "./HlhtAuths.vue?vue&type=script&lang=ts&setup=true"

import "./HlhtAuths.vue?vue&type=style&index=0&id=60eb0edd&lang=css"

const __exports__ = script;

export default __exports__